export const AssetAffected = [
  { value: "", label: "Select Asset" },
  { value: "Truck", label: "Truck" },
  { value: "Trailer", label: "Trailer" },
];
